import { workerAppTypes } from 'components/EmployedsList';

export const workerAppStatusConfig = {
  deleted: {
    background: '#E10D0D',
    text: 'Профиль удален',
  },
  notRegistered: {
    background: '#E10D0D',
    text: 'Не зарегистрирован',
  },
  onModeration: {
    background: '#E10D0D',
    text: 'Не зарегистрирован',
  },
  registered: {
    background: '#28A879',
    text: 'Зарегистрирован',
  },
  appExit: {
    background: '#E10D0D',
    text: 'Не зарегистрирован',
  },
};

export const fnsStatusConfig = {
  notConnected: {
    background: '#E10D0D',
    text: 'Не подключена',
  },
  connected: {
    background: '#28A879',
    text: 'Подключена',
  },
};

export const getWorkerAppStatus = (
  workerApp: workerAppTypes | undefined,
  isDeleted?: boolean,
) => {
  if (isDeleted) return 'deleted';
  if (!workerApp) return 'notRegistered';
  if ([0, 2, 6, 8, 10].includes(workerApp.app_status)) return 'notRegistered';
  if (workerApp.verified === 2) return 'onModeration';
  if (workerApp.app_exit === 1) return 'appExit';
  if (workerApp.verified === 1 && workerApp.moderated === 1) return 'registered';
  return 'notRegistered';
};

export const getFnsStatus = (workerApp: workerAppTypes | undefined) => {
  if (!workerApp) return 'notConnected';
  if (workerApp.fns_status === 1 || workerApp.fns_status === 2) return 'connected';
  return 'notConnected';
};
